import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import _ from 'lodash'
import ogImage from "../../images/posts/46/thumb-landscape.jpg"

import Slider from "react-slick";

const Post46 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,

    responsive: [
    {
      breakpoint: 1024,
      settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      }
    },
    {
      breakpoint: 599,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      }
    }
  ]    
  };

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Dior／レディディオール／31 x24 x11cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>Dior（ディオール）の王道アイコンバッグといえば、プリンセス ダイアナのイメージも強い「LADY DIOR（レディディオール）」ではないでしょうか？<br></br>今回はDior（ディオール）のブランドの歴史と、バッグの特徴、人気の秘密をご紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.Dior（ディオール）とは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.LADY DIOR（レディディオール）</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.LADY DIOR（レディディオール）の特徴</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.5つのサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.バニティーバッグ</ScrollLink><br></br>  
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>6.LADY DIOR（レディディオール）に合うコーデ</ScrollLink><br></br>  
          <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80}>7.まとめ</ScrollLink>
        </p>
      </div>               
      <div name="sec1" className="text-two-cloumn">
        <h2>1.Dior（ディオール）とは？</h2>
        <p>1946年フランスでクリスチャン・ディオールによって創設されたブランド。ブランド創設後、一気に世界のファッション業界のトップにまで駆け上がりました。しかし1957年、ディオールは53歳という若さでこの世を去ってしまいます。<br></br>彼の亡き後、ブランドを引き継いだのは、後に「モード界の帝王」とまで言われることとなる、あのイヴ・サンローラン。若き天才と呼ばれた彼は当時21歳という若さでブランドを任されることとなります。<br></br>その後、さまざまなデザイナーを経て、1996年サドル・バッグを考案した、ジョン・ガリアーノや、2016年に初の女性クリエイティブ・ディレクターとなり、ブックトートを考案したマリア・グラツィア・キウリなど数々の名デザイナーがDior（ディオール）というブランドを作り上げています。
        </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/46/1.jpg" alt="Dior（ディオール）の王道アイコンバッグ！LADY DIOR（レディディオール）"/>
        <span className="text-center">Dior／レディディオール／24 x20 x10cm</span>
      </figure>
      <div name="sec2" className="text-max-width">
        <h2>2.LADY DIOR（レディディオール）</h2>      
      <p>
        LADY DIOR（レディディオール）は、1994年に「カナージュ・キュイール」という名前で発売されたバッグ。フランス語で籐の編み目の革という意味です。<br></br>1995年、パリを訪れたダイアナ妃に、フランスのシラク大統領がこのバッグのブラックをプレゼントすると、ダイアナ妃はこのバッグをとても気に入り、すぐにディオール本店へと向かい当時7色展開あったバッグを全て購入したというのは有名な話。<br></br>ダイアナは公の場にも、このバッグを持って出かけることが多かったことから、世界中のメディアが注目し、結婚前のダイアナの愛称Lady Di（レディ・ディ）から名前を取り、LADY DIOR（レディディオール）という名前に変更し20年以上経った今でも人気のバッグとなっています。
      </p>
      </div>
      <div name="sec3" className="text-max-width">
        <h2>3.LADY DIOR（レディディオール）の特徴</h2>
        <p className="max-width">LADY DIOR（レディディオール）の特徴はやはり、「カナージュ」ステッチ入りのキルティング地です。またハンドルには独立した形でD・I・O・Rの4文字が、チャームがリッチなアクセントに。歩くたびに、ゆらゆらと揺れるチャームがとってもかわいい♡チャームは、シルバーやゴールドなどのさまざまなコーティング加工を施したものがあります。
        </p>         
        <figure>
          <StaticImage src="../../images/posts/46/2.jpg"/>
          <span className="text-center">Dior／レディディオール／31 x24 x11cm</span>
        </figure>
      </div>
      <div name="sec4" className="text-two-cloumn">
        <h2>4.5つのサイズ展開</h2>
        <p>現在LADY DIOR（レディディオール）は5つのサイズ展開があります。</p>
      </div>
      <div className="text-max-width">
      <h2>■ラージサイズ /32x25x11cm(幅x高さxマチ)</h2>
      <p>最も大きいサイズのラージ。唯一A4サイズも収納可能なので、お仕事バッグとしても◎
      </p>
      </div>            
      <figure>
        <StaticImage src="../../images/posts/46/3.jpg"/>
      </figure>
      <div className="text-max-width">
      <h2>■ミディアムサイズ /24x20x11cm(幅x高さxマチ)</h2>
      <p>こちらは発売当初からある定番、人気サイズ。あのダイアナ妃も愛用していたサイズです。カラー、バッグの素材ともに種類が豊富です。（一部ですが紹介しています）
      </p>
      </div>  
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/46/4.jpg"/>
        <StaticImage src="../../images/posts/46/5.jpg"/>
        <StaticImage src="../../images/posts/46/6.jpg"/>
        <StaticImage src="../../images/posts/46/7.jpg"/>
        <StaticImage src="../../images/posts/46/8.jpg"/>
      </Slider>
      <div className="text-max-width">
      <h2>■スモールサイズ /20x16.5x8cm(幅x高さxマチ)</h2>
      <p>大きすぎず、小さすぎず程よいサイズ感で人気のスモール。マチがあるので見た目よりも収納可能。
      </p>
      </div> 
      <figure className="img-small">
        <StaticImage src="../../images/posts/46/9.jpg"/>
      </figure>
      <div className="text-max-width">
      <h2>■ミニサイズ /17x15x7cm(幅x高さxマチ)</h2>
      <p>近年人気のミニサイズ。小さめウォレット、携帯などは収納可能でストラップのチェーンもアクセサリー感覚で取り入れやすく人気です。
      </p>
      </div>  
      <Slider className="slide-box" {...settings}>
        <StaticImage src="../../images/posts/46/10.jpg"/>
        <StaticImage src="../../images/posts/46/11.jpg"/>
        <StaticImage src="../../images/posts/46/12.jpg"/>
        <StaticImage src="../../images/posts/46/13.jpg"/>
        <StaticImage src="../../images/posts/46/14.jpg"/>
      </Slider>
      <div className="text-max-width">
      <h2>■マイクロサイズ /12x10x5cm(幅x高さxマチ)</h2>
      <p>（※現在、ラクサスでのお取り扱いはございません）
      </p>
      </div>                                                  
      <Link to="https://laxus.co/app/pc/bags/dior" className="view-all-button">
       Diorのバッグを見る
      </Link>         
      <div name="sec5" className="text-max-width">
        <h2>5.バニティーバッグ</h2>
      </div>
      <h2>■スモールバニティーバッグ /18x13x10cm(幅x高さxマチ)</h2>
      <figure>
        <StaticImage src="../../images/posts/46/15.jpg"/>
      </figure>  
      <p className="text-max-width">2021年には、キュートなバニティーバッグが登場。ストラップも取り外し可能で、2wayでの利用が可能です。
      </p>
      <div name="sec6" className="text-max-width">
        <h2>6.LADY DIOR（レディディオール）に合うコーデ</h2>
        <p>LADY DIOR（レディディオール）のデザインはクラシカルな装いにも合うようなデザインです。</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/46/16.png"/>
        <span className="text-center">Dior／レディディオールミニ／17 x14 x6cm</span>
      </figure>
      <span className="text-center">ワンピースに合わせてお出かけスタイルに</span>
      <div className="text-max-width">
        <p>また、キルティング生地のカナージュステッチはカジュアルなアイテムとも好相性。</p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/46/17.png"/>
        <span className="text-center">Dior／レディディオール／24 x20 x12cm</span>
      </figure>
      <span className="text-center">ジーンズでカジュアルに</span>
      <div name="sec7" className="text-two-cloumn">
        <h2>7.まとめ</h2>
        <p>いかがでしたか？ディオールは伝統的なデザインを守りつつ、既存のデザインを壊しながら革新的に成長しているブランドのひとつです。<br></br>まずは、バッグを検索してみませんか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/dior" className="view-all-button">
       Diorのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post46

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 46}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
